const initialState = {
  isLoading: false,
  error: '',
  isOpen: false,
  data: {
    id: '',
    thread: [],
  },
};

export default initialState;
